module.exports = __webpack_public_path__ + "media/images/meetlogo-4c938972241e06db9999f9925f0f7ac0.png";